import PropTypes from 'prop-types';
import React from 'react';

export default class TextArea extends React.Component {
  static propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    validate: PropTypes.func,
    onChange: PropTypes.func.isRequired
  };

  state = {
    value: this.props.value,
    error: false
  };

  componentWillReceiveProps(update) {
    this.setState({ value: update.value });
  }

  onChange = evt => {
    const name = this.props.name;
    const value = evt.target.value;
    const error = this.props.validate ? this.props.validate(value) : false;

    this.setState({ value, error });

    this.props.onChange({ name, value, error });
  };

  render() {
    return (
      <div className="field">
        <label className="label">{this.props.placeholder}</label>
        <div className="control">
          <textarea
            className={`textarea ${
              this.props.value.length
                ? this.state.error ? 'is-danger' : 'is-success'
                : ''
            }`}
            placeholder={this.props.placeholder}
            value={this.state.value}
            onChange={this.onChange}
          />
        </div>
        <p className="help has-text-danger">{this.state.error}</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/TextArea.js